// Données simulées basées sur votre structure de table tour_stops
export interface TourStop {
  id: number;
  country: string;
  location: string;
  dates: string;
  month: string;
  year: number;
  image_url: string;
  description_fr: string;
  description_en: string;
  highlights_fr: string[];
  highlights_en: string[];
  participants: number;
  prize_pool: string;
  winner_men: string | null;
  winner_women: string | null;
  created_at: string;
  updated_at: string;
  status: 'completed' | 'upcoming' | 'featured';
  spot: string;
}

export const tourStopsData: TourStop[] = [
  {
    id: 1,
    country: 'Sénégal',
    location: 'Dakar',
    dates: '15-20 Mars 2024',
    month: 'Mars',
    year: 2024,
    image_url: 'https://images.pexels.com/photos/17155141/pexels-photo-17155141.jpeg',
    description_fr: 'Première étape du tour dans les vagues puissantes de Yoff, berceau du surf sénégalais. Une compétition intense dans des conditions parfaites.',
    description_en: 'First stop of the tour in the powerful waves of Yoff, birthplace of Senegalese surfing. An intense competition in perfect conditions.',
    highlights_fr: [
      '48 surfeurs de 8 pays africains',
      'Conditions parfaites avec 4-6 pieds',
      'Performance exceptionnelle de Cherif Fall',
      'Festival culturel wolof en parallèle'
    ],
    highlights_en: [
      '48 surfers from 8 African countries',
      'Perfect conditions with 4-6 feet waves',
      'Exceptional performance by Cherif Fall',
      'Parallel Wolof cultural festival'
    ],
    participants: 48,
    prize_pool: '25,000€',
    winner_men: 'Cherif Fall',
    winner_women: 'Amina Diop',
    created_at: '2024-01-15T10:00:00Z',
    updated_at: '2024-03-20T18:30:00Z',
    status: 'completed',
    spot: 'Yoff Beach'
  },
  {
    id: 2,
    country: 'Maroc',
    location: 'Taghazout',
    dates: '10-15 Avril 2024',
    month: 'Avril',
    year: 2024,
    image_url: 'https://images.pexels.com/photos/17105549/pexels-photo-17105549.jpeg',
    description_fr: 'Conditions exceptionnelles sur le reef break légendaire d\'Anchor Point. Les meilleurs surfeurs africains s\'affrontent sur l\'une des vagues les plus techniques du continent.',
    description_en: 'Exceptional conditions on the legendary Anchor Point reef break. The best African surfers compete on one of the most technical waves on the continent.',
    highlights_fr: [
      '52 surfeurs qualifiés',
      'Vagues de 6-8 pieds parfaitement formées',
      'Victoire historique de Youssef Benali',
      'Retransmission live internationale'
    ],
    highlights_en: [
      '52 qualified surfers',
      'Perfectly formed 6-8 feet waves',
      'Historic victory by Youssef Benali',
      'International live broadcast'
    ],
    participants: 52,
    prize_pool: '30,000€',
    winner_men: 'Youssef Benali',
    winner_women: 'Fatima El Mansouri',
    created_at: '2024-02-01T09:00:00Z',
    updated_at: '2024-04-15T20:15:00Z',
    status: 'completed',
    spot: 'Anchor Point'
  },
  {
    id: 3,
    country: 'Ghana',
    location: 'Busua',
    dates: '15-20 Mai 2024',
    month: 'Mai',
    year: 2024,
    image_url: 'https://images.pexels.com/photos/1032650/pexels-photo-1032650.jpg',
    description_fr: 'Finale épique du championnat ASC 2024. Les 32 meilleurs surfeurs du continent s\'affrontent pour le titre de Champion d\'Afrique sur les vagues parfaites de Busua Beach.',
    description_en: 'Epic finale of the ASC 2024 championship. The 32 best surfers on the continent compete for the title of African Champion on the perfect waves of Busua Beach.',
    highlights_fr: [
      '32 surfeurs qualifiés de 15 pays',
      'Prize money de 50,000€',
      'Retransmission live internationale',
      'Festival culturel et concerts',
      'Cérémonie de clôture spectaculaire'
    ],
    highlights_en: [
      '32 qualified surfers from 15 countries',
      '50,000€ prize money',
      'International live broadcast',
      'Cultural festival and concerts',
      'Spectacular closing ceremony'
    ],
    participants: 32,
    prize_pool: '50,000€',
    winner_men: null,
    winner_women: null,
    created_at: '2024-03-01T08:00:00Z',
    updated_at: '2024-04-20T14:30:00Z',
    status: 'featured',
    spot: 'Busua Beach'
  },
  {
    id: 4,
    country: 'Libéria',
    location: 'Robertsport',
    dates: '20-25 Juin 2024',
    month: 'Juin',
    year: 2024,
    image_url: 'https://images.pexels.com/photos/8721342/pexels-photo-8721342.jpg',
    description_fr: 'Découverte de l\'un des secrets les mieux gardés du surf africain. Robertsport offre des vagues de classe mondiale dans un cadre préservé et authentique.',
    description_en: 'Discovery of one of the best-kept secrets of African surfing. Robertsport offers world-class waves in a preserved and authentic setting.',
    highlights_fr: [
      '38 surfeurs sélectionnés',
      'Vagues puissantes de Fisherman\'s Lake',
      'Première compétition internationale au Libéria',
      'Développement du surf local'
    ],
    highlights_en: [
      '38 selected surfers',
      'Powerful waves at Fisherman\'s Lake',
      'First international competition in Liberia',
      'Local surf development'
    ],
    participants: 38,
    prize_pool: '20,000€',
    winner_men: null,
    winner_women: null,
    created_at: '2024-03-15T11:00:00Z',
    updated_at: '2024-04-01T16:45:00Z',
    status: 'upcoming',
    spot: 'Fisherman\'s Lake'
  },
  {
    id: 5,
    country: 'Afrique du Sud',
    location: 'Jeffreys Bay',
    dates: '15-20 Juillet 2024',
    month: 'Juillet',
    year: 2024,
    image_url: 'https://images.pexels.com/photos/1029604/pexels-photo-1029604.jpg',
    description_fr: 'Grande finale sur l\'une des vagues les plus célèbres au monde. J-Bay accueille l\'élite du surf africain pour une conclusion spectaculaire du tour.',
    description_en: 'Grand finale on one of the most famous waves in the world. J-Bay hosts the African surfing elite for a spectacular conclusion to the tour.',
    highlights_fr: [
      '64 surfeurs de tout le continent',
      'Vagues légendaires de Supertubes',
      'Finale du classement général',
      'Cérémonie de remise des prix'
    ],
    highlights_en: [
      '64 surfers from across the continent',
      'Legendary Supertubes waves',
      'General classification finale',
      'Awards ceremony'
    ],
    participants: 64,
    prize_pool: '75,000€',
    winner_men: null,
    winner_women: null,
    created_at: '2024-04-01T12:00:00Z',
    updated_at: '2024-04-01T12:00:00Z',
    status: 'upcoming',
    spot: 'Supertubes'
  }
];

// Fonction pour obtenir l'événement à la une
export const getFeaturedEvent = (): TourStop | null => {
  return tourStopsData.find(stop => stop.status === 'featured') || null;
};

// Fonction pour obtenir tous les événements
export const getAllTourStops = (): TourStop[] => {
  return tourStopsData;
};

// Fonction pour obtenir un événement par ID
export const getTourStopById = (id: number): TourStop | null => {
  return tourStopsData.find(stop => stop.id === id) || null;
};